import { CommonModule } from '@angular/common';
import {
  Component, EventEmitter,
  Input, LOCALE_ID, OnInit, Output,
} from '@angular/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import {
  MoonStatusResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/moon-status.response';
import { WeatherApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/location/weather/weather-api';
import { LunarApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/lunar/lunar-api';
import {
  LunarDayResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/lunar/lunar-day.response';
import { TranslateModule } from '@ngx-translate/core';
import {
  WeatherStatusResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/weather-status.response';
import { SkeletonLoaderComponent } from '../../../@commons/@components/loaders/skeleton-loader/skeleton-loader.component';
import { ChevronRightIconComponent } from '../../../@icons/moon-icon.component';
import { ExtendableCardComponent } from '../../../@commons/@components/cards/extendable-card/extendable-card.component';

@Component({
  selector: 'vw-moon-info-card',
  imports: [CommonModule, SharedModule, ExtendableCardComponent, TranslateModule, SkeletonLoaderComponent, ChevronRightIconComponent],
  templateUrl: './moon-info-card.component.html',
  styleUrl: './moon-info-card.component.scss',
  providers: [
    {
      provide: WeatherApi,
      useClass: WeatherApi
    },
    {
      provide: LunarApi,
      useClass: LunarApi
    },
    { provide: LOCALE_ID, useValue: 'fr' }
  ]
})
export class MoonInfoCardComponent implements OnInit {

  @Input() labelClass: string = ''; // labelClass of the card for css


  @Output() toggle: EventEmitter<boolean> = new EventEmitter<boolean>(); // Event emitter to notify parent component about the state change
  @Output() cardClick: EventEmitter<any> = new EventEmitter<any>(); // Event for card click handling

  weatherImg: string = '/assets/svg/moon/moon-tree.svg';
  iconUrl: string = '/assets/svg/moon/moon.svg';
  currentDate: Date = new Date();
  backgroundColor = '#051038';
  moonData: MoonStatusResponse;
  lunarDay: LunarDayResponse;
  currentWeather: WeatherStatusResponse = null;
  isLoading: boolean = true;

  constructor(
    private weatherApi: WeatherApi,
    private lunarApi: LunarApi,
  ) {
  }
  async ngOnInit() {
    await Promise.all([this.loadMoonInfo(), this.loadWeatherInfo(), this.loadLunarInfo()]);
    this.isLoading = false;
  }

  async loadWeatherInfo() {
    this.currentWeather = await this.weatherApi.getStatus();
  }

  async loadMoonInfo() {
    this.moonData = await this.weatherApi.getMoonStatus();
  }

  async loadLunarInfo() {
    try {
      const today = this.currentDate.toISOString().slice(0, 10);
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const calendar = await this.lunarApi.getCalendar(today, today, '50.85,4.35', tz);
      if (calendar?.items?.length > 0) {
        this.lunarDay = calendar.items[0];
      }
    } catch (e) {
      console.warn('Failed to load lunar data', e);
    }
  }

  get moonPathIcon(): string {
    if (!this.lunarDay) return '';
    return this.lunarDay.moonPath === 'montante' ? '↑' : '↓';
  }
}
